/**
 * @module experience/shop/cart/line-setup
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const LINE_SETUP_COMPONENTS = {
  LINE_SETUP_MODULE: 'LineSetupModule',
  LINE_SETUP_SERVICE: 'LineSetupService',
  EXISTING_NUMBER_RADIO_COMPONENT: 'ExistingNumberRadioComponent',
  LINE_ADDRESS_FORM_COMPONENT: 'LineAddressFormComponent',
  LINE_SETUP_CONTINUE_CTA_COMPONENT: 'LineSetupContinueCtaComponent',
  LINE_SETUP_EDIT_CTA_COMPONENT: 'LineSetupEditCtaComponent',
  LINE_SETUP_LANDING_COMPONENT: 'LineSetupLandingComponent',
  NEW_NUMBER_MODAL_COMPONENT: 'NewNumberModalComponent',
  NEW_NUMBER_RADIO_COMPONENT: 'NewNumberRadioComponent',
  ZIP_CODE_ONINIT: 'zipCodeOnInit',
  ZIP_AREA_CODE_PORT: 'zipAreaCodePort',
  ZIP_CODE: 'zipCode',
  AREA_CODE_FROM_DROPDOWN: 'areaCodeFromDropdown',
  INVALID_ZIPCODE: 'Invalid Zip Code. Please enter valid Zip Code',
};

export const SPINNER_DELAY = 1000;

/**
 * Enum values for Opt In/Out
 */
export enum OptOptionEnum {
  OPTIN,
  OPTOUT,
}

export enum NumberOptions {
  newNumber,
  existingNumber,
  existingPortIn,
  reservedNumber,
}

export enum zipCodeOptions {
  zipCode,
  zipAreaCodePort,
  zipCodeSearchForm,
  billingZipCode,
}

export const PhoneNumberLength = 10;
export const MaxNumberRetrieval = 5;
export const npaNxxLength = 7;

export const LINE_SETUP_CONSTANTS = {
  CHECKED: 'checked',
  LEGAL_TEXT: 'legal-text',
  BILLING: 'BILLING',
  PPU: 'PPU',
  E911: 'E911',
  USE_ADDRESS: 'useAddressChkBox',
  ZIP: 'zip',
  ONE: 1,
  FULL_ADDRESS: 'fullAddress',
  CART_ORDER_REVIEW: '/cart/order-review',
  ORDER_PAYMENT: '/cart/payment',
  SUGGESTED_NUMBER: '({0}) {1}-****',
  SUGGESTED_MSISDN: '({0}) {1}-{2}',
  ADDED: 'ADDED',
  NEWNUMBER: 'newNumber',
  CHANGED: 'CHANGED',
  NEW_ADDRESS: 'New Address',
  NEW_ADDRESS_LABEL: 'newAddress',
  NO_ADDRESS_FOUND: 'Address not found',
};

export const EPAY_CONSTANTS = {
  CHANNEL: 'RAP',
  PAYMENT_TYPE: 'Activation',
  APN: 'iTNACP',
  DEALER_NAME: 'Tmobile Dealer Name',
  BRAND: 'TIP',
};
